import { useEffect } from 'react'

const useTitle = (title?: string) => {
  useEffect(() => {
    if (!title) return
    document.title = title
  }, [title])
}

export default useTitle
